module.exports = __webpack_public_path__ + "img/Info Hover.acee6e27.svg";